import { forwardRef } from 'react';

import { cls } from '@/utils/cls';

export type AccureIconProps = {
  className?: string;
};

const AccureIcon = forwardRef<SVGSVGElement, AccureIconProps>(
  ({ className }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls('size-full text-primary-500', className)}
    >
      <path
        d="M1.92157 19.5771H0V21.3709H1.92157V19.5771Z"
        fill="currentcolor"
      />
      <path
        d="M1.92157 12.4073H0V14.201H1.92157V12.4073Z"
        fill="currentcolor"
      />
      <path
        d="M3.84332 10.624H1.92175V12.4178H3.84332V10.624Z"
        fill="currentcolor"
      />
      <path
        d="M1.92157 7.04166H0V8.83542H1.92157V7.04166Z"
        fill="currentcolor"
      />
      <path
        d="M5.76471 12.4125H3.84314V14.2063H5.76471V12.4125Z"
        fill="currentcolor"
      />
      <path
        d="M21.4736 7.06784H15.877C15.4407 7.06784 15.087 7.39798 15.087 7.80522V24.1949C15.087 24.6021 15.4407 24.9322 15.877 24.9322H21.4736C21.9098 24.9322 22.2635 24.6021 22.2635 24.1949V7.80522C22.2635 7.39798 21.9098 7.06784 21.4736 7.06784Z"
        fill="currentcolor"
      />
      <path
        d="M31.2102 7.07306H25.6135C25.1773 7.07306 24.8236 7.40319 24.8236 7.81044V24.2001C24.8236 24.6073 25.1773 24.9375 25.6135 24.9375H31.2102C31.6464 24.9375 32.0001 24.6073 32.0001 24.2001V7.81044C32.0001 7.40319 31.6464 7.07306 31.2102 7.07306Z"
        fill="currentcolor"
      />
      <path
        d="M7.68085 7.04167V8.83543H5.75928V7.04167H3.83772V8.83543V10.6292H5.75368V12.4177H7.67525V14.2063H5.75368V16.0052H1.92175V17.799H3.84332V19.5875H5.75928V21.3813H7.68085V23.1698H5.75928V21.3813H3.84332V23.1698H1.92175V24.9636H11.7313C12.1738 24.9636 12.5268 24.6289 12.5268 24.221V7.77904C12.5268 7.3659 12.1682 7.03644 11.7313 7.03644H7.67525L7.68085 7.04167ZM9.59681 19.5771H7.67525V17.7885H9.59681V19.5771Z"
        fill="currentcolor"
      />
    </svg>
  ),
);

AccureIcon.displayName = 'AccureIcon';
export { AccureIcon };
